import React from 'react';
import { Box } from '@mui/material';
import {
  Business as SiteIcon,
  Apartment as BuildingIcon,
  Layers as FloorIcon,
  MeetingRoom as UnitIcon,
  Room as RoomIcon,
  GridView as ZoneIcon,
  LinearScale as HallwayIcon,
  Groups as CommonAreaIcon,
  Park as GardenIcon,
  LocalParking as ParkingIcon,
  Warehouse as StorageIcon,
  Construction as TechnicalIcon,
  Work as OfficeIcon,
  Kitchen as KitchenIcon,
  Bathroom as BathroomIcon,
  DoorFront as EntranceIcon,
  Stairs as StairsIcon,
  Elevator as ElevatorIcon,
  LocationOn as DefaultIcon
} from '@mui/icons-material';
import { getLocationTypeConfig } from '../../utils/locationConstants';

const ICON_MAP = {
  Business: SiteIcon,
  Apartment: BuildingIcon,
  Layers: FloorIcon,
  MeetingRoom: UnitIcon,
  Room: RoomIcon,
  GridView: ZoneIcon,
  LinearScale: HallwayIcon,
  Groups: CommonAreaIcon,
  Park: GardenIcon,
  LocalParking: ParkingIcon,
  Warehouse: StorageIcon,
  Construction: TechnicalIcon,
  Work: OfficeIcon,
  Kitchen: KitchenIcon,
  Bathroom: BathroomIcon,
  DoorFront: EntranceIcon,
  Stairs: StairsIcon,
  Elevator: ElevatorIcon,
  LocationOn: DefaultIcon
};

/**
 * Renders a location type icon with appropriate color
 * @param {number} typeId - Location type ID
 * @param {number} size - Icon size in px (default 24)
 * @param {boolean} withBackground - Show colored background circle
 * @param {object} sx - Additional MUI sx props
 */
const LocationTypeIcon = ({ typeId, size = 24, withBackground = false, sx = {} }) => {
  const config = getLocationTypeConfig(typeId);
  const IconComponent = ICON_MAP[config.icon] || DefaultIcon;

  if (withBackground) {
    return (
      <Box
        sx={{
          p: size > 24 ? 1.5 : 1,
          borderRadius: 2,
          bgcolor: config.color,
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...sx
        }}
      >
        <IconComponent sx={{ fontSize: size }} />
      </Box>
    );
  }

  return (
    <IconComponent
      sx={{
        fontSize: size,
        color: config.color,
        ...sx
      }}
    />
  );
};

export default LocationTypeIcon;
